<template>
  <div class="recruit_container">
    <div class="recruit_section04">
      <div class="recruit_head">03. 근무환경</div>
      <v-img
        src="../../assets/img/recruit/icon_recruit_new_workplace.jpg"
      ></v-img>
    </div>
  </div>
</template>
<script>
export default {
  name: "section04",
};
</script>
